import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TTypeBid } from 'src/app/models/auction';
import { IAuctionBid } from 'src/app/models/transactions';
import { AuctionService } from 'src/app/services/auction.service';
import { SnackbarService } from 'src/app/services/snackbar.service';
import { StorageService } from 'src/app/services/storage.service';
import { ValidatorUtils } from 'src/app/utils/validator.utils';

@Component({
  selector: 'app-popup-real-time-bidding',
  templateUrl: './popup-real-time-bidding.component.html',
  styleUrls: ['./popup-real-time-bidding.component.scss'],
})
export class PopupRealTimeBiddingComponent implements OnInit {
  constructor(
    private dialogRef: MatDialogRef<PopupRealTimeBiddingComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private auctionService: AuctionService,
    private storage: StorageService,
    private snackbar: SnackbarService
  ) {}

  loading = true;
  animal: any = {} as any;
  auction_bid: IAuctionBid = {} as IAuctionBid;
  phase = 1;
  titleOnline = 'Lance On-line';
  titlePre = 'Pre Lance';

  // id = 0;
  select_bid: any;
  next_bid = 0;
  attual_bid: any;
  newbid: any = '';
  increment: any;
  type: TTypeBid = 'PRELANCE';
  min_bid: any;
  max_bid: any;

  enableBid = true;
  real_time = false;
  list_bids: any = [];
  timer: any = ''; // 3 minutos
  statusBid: any = '';
  Interval: any = null;
  validator = new ValidatorUtils();
  id_schedule_event = 0;

  socket = new WebSocket('wss://socket.wvleiloes.com/');

  ngOnInit(): void {
    // this.id = this.data.id;
    this.animal = this.data.animal;
    this.increment = this.data.increment;
    this.auction_bid = this.data.auction_bid;
    this.attual_bid = this.data.attual_bid;
    this.newbid = this.data.next_bid;
    const value = Number(this.data.attual_bid || 0)
    this.max_bid =
      Number(value.toFixed(0)) + this.data.increment * 10;
    this.enableBid = this.data.enableBid;
    this.timer = this.data.timer;
    this.type = this.data.type;
    this.min_bid = this.data.attual_bid;

    if (this.next_bid <= 0) {
      this.next_bid = this.data.attual_bid;
    }

    if (!this.real_time) {
      this.Interval = setInterval(() => {
        this.getListBid();
      }, 1000);
    }

    this.loading = false;
  }

  nextPhase() {
    if (this.phase === 3) {
      this.finish();
    } else if (this.phase < 5) {
      this.phase++;

      if (this.phase === 3) {
        this.titleOnline = 'Finalizar Lance';
        this.titlePre = 'Finalizar Lance';
      } else if (this.phase === 4) {
        this.titleOnline = 'Parabéns!';
        this.titlePre = 'Parabéns!';
      }
    }
  }

  chance(chance: 'yes' | 'no' | 'login', results?: any): void {
    this.dialogRef.close({ action: 'no' });
  }

  convertMoney(money: any) {
    return this.validator.convertMoney(money);
  }

  changeBid(event: any) {
    this.next_bid = event.value;
  }

  formatLabel(value: number) {
    return value;
  }

  getDiffDate() {
    const dataEnd = new Date(this.animal.schedule_event?.finish_date);

    const now = new Date();
    let lastBid: any = new Date();

    if (this.list_bids.length > 0) {
      lastBid = new Date(this.list_bids[0].updated_at);

      if (lastBid.getTime() > dataEnd.getTime()) {
        lastBid = new Date(this.list_bids[0].updated_at);
      } else {
        lastBid = dataEnd;
      }
    } else {
      lastBid = dataEnd;
    }

    const diff = now.getTime() - lastBid.getTime(); // pega a diferença

    // this.time.min = Math.trunc(this.timer / (1000 * 60) - diff / (1000 * 60)); // Diff em minutos
    // this.time.seg = Math.trunc((this.timer / 1000 - diff / 1000) % 60); // Diff em segundos

    // if (this.time.min < -1 || this.time.seg < -1) {
    //   clearInterval(this.openingTime);
    //   this.bid_status = 'FINISH';
    // }

    // const diff = now.getTime() - lastBid.getTime(); // pegar a diferença

    // if (!this.real_time && this.timer !== null) {
    //   if (Math.trunc((this.timer / 1000 - diff / 1000) % 60) < 0) {
    //     this.enableBid = false;
    //   } else {
    //     this.enableBid = true;
    //   }
    // }

    if (this.timer === null) {
      clearInterval(this.Interval);
    }
  }

  finish() {
    if (this.loading) return;

    if (['VIRTUAL'].includes(this.type)) {
      this.sendBidOverrun();
    } else if (['AOVIVO'].includes(this.type)) {
      this.sendOnlineBidOverta();
    } else {
      this.sendPreBidOverta();
    }
  }

  sendBidOverrun() {
    this.loading = true;
    this.auctionService
      .sendBidOverrun(this.animal.id, this.next_bid, Number(this.increment))
      .subscribe(
        (data) => {
          this.phase++;
          this.titleOnline = 'Parabéns!';
          this.titlePre = 'Parabéns!';
          clearInterval(this.Interval);
          this.socket.send('Atualizar');
          // this.socket.send('LANCE');
          this.loading = false;
        },
        (error) => {
          if(error === 'Leilão já foi finalizado'){
            this.dialogRef.close({ action: 'no' });
            this.snackbar.error('Leilão já foi finalizado');
          }
          this.loading = false;
        }
      );
  }

  sendOnlineBidOverta() {
    this.loading = true;
    this.auctionService
      .sendOnlineBidOverta(this.animal.id, this.next_bid, Number(this.increment))
      .subscribe(
        (data) => {
          this.phase++;
          this.titleOnline = 'Parabéns!';
          this.titlePre = 'Parabéns!';
          clearInterval(this.Interval);
          this.socket.send('Atualizar');
          // this.socket.send('LANCE');
          this.loading = false;
        },
        (error) => {
          if(error === 'Leilão já foi finalizado'){
            this.dialogRef.close({ action: 'no' });
            this.snackbar.error('Leilão já foi finalizado')
          }
          this.loading = false;
        }
      );
  }

  sendPreBidOverta() {
    this.loading = true;

    this.auctionService
      .sendPreBidOverta(this.animal.id, this.next_bid, Number(this.increment))
      .subscribe(
        (data) => {
          this.phase++;
          this.titleOnline = 'Parabéns!';
          this.titlePre = 'Parabéns!';
          clearInterval(this.Interval);
          this.socket.send('Atualizar');
          // this.socket.send('LANCE');
          this.loading = false;
        },
        (error) => {
          if(error === 'Leilão já foi finalizado'){
            this.dialogRef.close({ action: 'no' });
            this.snackbar.error('Leilão já foi finalizado')
          }
          this.loading = false;
        }
      );
  }

  getListBid() {
    const status = 'ACEITO';
    this.auctionService.getListBid(this.animal.id, status).subscribe({
      next: (data) => {
        data.forEach((item: any) => {
          this.list_bids = data;
        });
        this.getDiffDate();
      },
      error: () => {
        this.getDiffDate();
      }
    });
  }
}
